import { ExtractPropTypes, InjectionKey, PropType, SetupContext } from 'vue'

export type typeKey = string | number

export interface TreeNode extends Required<TreeOption> {
  level: number
  rawNode: TreeOption
  children: TreeNode[]
  isLeaf: boolean,
  parentKey: typeKey | undefined
}

export interface TreeOption {
  key?: typeKey
  label?: typeKey
  children?: TreeOption[]
  isLeaf?: boolean
  disabled?: boolean
  [key: string]: unknown // 任意字段
}

export const treeProps = {
  data: {
    type: Array as PropType<TreeOption[]>,
    default: () => []
  },
  defaultExpandedKeys: {
    type: Array as PropType<typeKey[]>
  },
  keyField: {
    type: String,
    default: 'key'
  },
  labelField: {
    type: String,
    default: 'label'
  },
  childrenField: {
    type: String,
    default: 'children'
  },
  onLoad: {
    type: Function as PropType<(node: TreeOption) => Promise<TreeOption[]>>
  },
  selectedKeys: {
    type: Array as PropType<typeKey[]>
  },
  selectable: {
    type: Boolean,
    default: true
  },
  multiple: {
    type: Boolean,
    default: false
  },
  defaultCheckedKeys: {
    type: Array as PropType<typeKey[]>,
    default: () => []
  },
  showCheckbox: {
    type: Boolean,
    default: false
  }
} as const

export const treeNodeProps = {
  node: {
    type: Object as PropType<TreeNode>,
    required: true
  },
  expanded: {
    type: Boolean,
    require: true
  },
  loadingKeys: {
    type: Object as PropType<Set<typeKey>>,
    require: true
  },
  selectedKeys: {
    type: Array as PropType<typeKey[]>,
    default: () => []
  },
  showCheckbox: {
    type: Boolean,
    default: false
  },
  checked: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  indeterminte: {
    type: Boolean,
    default: false
  }
} as const

export const treeEmitts = {
  // 内部发射的事件用来同步响应式数据
  'update:selectedKeys': (keys: typeKey[]) => keys
}

export const treeNodeEmitts = {
  toggle: (node: TreeNode) => node,
  select: (node: TreeNode) => node,
  check: (node: TreeNode, val: boolean) => typeof val === 'boolean',
}

export type TreeNodeProps = Partial<ExtractPropTypes<typeof treeNodeProps>>
export type TreeProps = Partial<ExtractPropTypes<typeof treeProps>>

export interface TreeContent {
  slots: SetupContext['slots']
  // emit: SetupContext['emit']
}

// 此变量提供出去的属性
export const treeInjectKey: InjectionKey<TreeContent> = Symbol()
export const treeNodeContentProps = {
  node: {
    type: Object as PropType<TreeNode>,
    require: true
  }
}
